import { motion } from 'framer-motion'
import { Target, Eye } from 'lucide-react'
import { aboutContent, seoMeta } from '../data/pages'
import { useScrollAnimation } from '../hooks/useScrollAnimation'
import { getIcon } from '../components/IconMap'
import SEO from '../components/SEO'

export default function AboutPage() {
  const { ref: missionRef, isVisible: missionVisible } = useScrollAnimation()
  const { ref: valuesRef, isVisible: valuesVisible } = useScrollAnimation()

  return (
    <>
      <SEO title={seoMeta.about.title} description={seoMeta.about.description} />

      <section className="relative bg-earth-900 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blossom-950 via-earth-900 to-prime-950" />
        <div className="absolute top-0 right-0 w-96 h-96 bg-blossom-500/10 rounded-full blur-3xl" />
        <div className="container-wide section-padding relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <span className="badge-green mb-4">About Us</span>
            <h1 className="text-display-1 font-bold text-white mb-4">Your Trusted Cleaning Partner</h1>
            <p className="text-earth-300 text-lg max-w-2xl">Blossom Prime Facility Solutions was founded on a clear and straightforward principle: that every environment deserves to be clean, safe and welcoming.</p>
          </motion.div>
        </div>
      </section>

      <section className="section-padding-y section-padding bg-earth-50">
        <div className="container-wide">
          <motion.div ref={missionRef} initial={{ opacity: 0, y: 30 }} animate={missionVisible ? { opacity: 1, y: 0 } : {}} className="grid lg:grid-cols-2 gap-8 mb-16">
            <div className="bg-gradient-to-br from-blossom-600 to-blossom-700 rounded-3xl p-8 lg:p-12 text-white">
              <Target className="w-10 h-10 mb-6 opacity-80" />
              <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
              <p className="text-blossom-100 text-lg leading-relaxed">{aboutContent.mission}</p>
            </div>
            <div className="bg-gradient-to-br from-prime-600 to-prime-700 rounded-3xl p-8 lg:p-12 text-white">
              <Eye className="w-10 h-10 mb-6 opacity-80" />
              <h2 className="text-2xl font-bold mb-4">Our Vision</h2>
              <p className="text-prime-100 text-lg leading-relaxed">{aboutContent.vision}</p>
            </div>
          </motion.div>

          <motion.div ref={valuesRef} initial={{ opacity: 0, y: 30 }} animate={valuesVisible ? { opacity: 1, y: 0 } : {}}>
            <h2 className="text-display-3 font-bold text-earth-900 text-center mb-12">Our Core Values</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {aboutContent.values.map((value, index) => {
                const Icon = getIcon(value.icon)
                return (
                  <motion.div key={value.title} initial={{ opacity: 0, y: 20 }} animate={valuesVisible ? { opacity: 1, y: 0 } : {}} transition={{ delay: index * 0.1 }}
                    className="bg-white rounded-2xl p-8 shadow-sm border border-earth-100">
                    <div className="w-14 h-14 rounded-2xl bg-blossom-100 flex items-center justify-center mb-5">
                      <Icon className="w-7 h-7 text-blossom-600" />
                    </div>
                    <h3 className="text-xl font-bold text-earth-900 mb-3">{value.title}</h3>
                    <p className="text-earth-500 leading-relaxed">{value.description}</p>
                  </motion.div>
                )
              })}
            </div>
          </motion.div>
        </div>
      </section>

    </>
  )
}
